var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 49,
    viewBox: "0 0 61 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.82959 47.73H59.8496",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6796 1C22.6796 4.68 18.6796 4.68 18.6796 8.36C18.6796 12.04 22.6796 12.04 22.6796 15.72C22.6796 19.4 18.6796 19.4 18.6796 23.08",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4196 1C32.4196 4.68 28.4196 4.68 28.4196 8.36C28.4196 12.04 32.4196 12.04 32.4196 15.72C32.4196 19.4 28.4196 19.4 28.4196 23.08",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1696 1C42.1696 4.68 38.1696 4.68 38.1696 8.36C38.1696 12.04 42.1696 12.04 42.1696 15.72C42.1696 19.4 38.1696 19.4 38.1696 23.08",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4795 47.73H27.3695C20.4195 47.73 14.7795 42.09 14.7795 35.14V27.09H46.0795V35.14C46.0695 42.09 40.4295 47.73 33.4795 47.73Z",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7695 27.09C49.8695 27.09 52.3795 29.4 52.3795 32.25C52.3795 35.1 49.8395 37.79 46.0995 37.41",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.02,
    height: 48.73,
    fill: "white",
    transform: "translate(0.82959)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.8af8c51146a963ecb69ea070065ca198.svg";
export { ForwardRef as ReactComponent };